import React from "react"
import BaseComponent from "../__application/BaseComponent"
import RewardTimer from "./_RewardTimer"
import StatusNav from "./_StatusNav"
import Shipping from "./_Shipping"

class Page extends BaseComponent {
  constructor(props) {
    super(props)
  }

  render() {
    return (
        <div className="reg2 new-reg address-step grid-x grid-margin-x">

          <RewardTimer />

          <div className="reg2-page-title cell medium-12">Your account has been created!</div>

          <div className="cell medium-6">
            <StatusNav step="shipping"/>
          </div>

          <div className="cell medium-6">
            <Shipping geo_data={this.props.geo_data} />
          </div>
        </div>
      )
  }
}

export default Page
